import React, { PropTypes } from "react";
import { ControlLabel, FormGroup, HelpBlock } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const CheckboxInput = (props, context) => {
  const {
    input,
    label,
    meta: { touched, error },
    checkbox,
    groupClassName,
    id,
    onChange,
    required,
    checked,
    ...rest
  } = props;
  const validationState = touched && !!error ? error.state : null;
  const validationMessageKey =
    !!error && error.messageKey ? error.messageKey : null;
  const validationValues = !!error && error.values ? error.values : null;
  const scene = context.scene ? "-" + context.scene : "";

  return (
    <FormGroup
      className={groupClassName}
      controlId={id + scene}
      validationState={validationState}
    >
      {label && (
        <ControlLabel>
          {label}
          {required ? <span className="required"> *</span> : ""}
        </ControlLabel>
      )}
      <div className="input-wrapper">
        <label>
          <input
            {...input}
            {...rest}
            type="checkbox"
            name={input.name}
            id={input.name}
            onChange={(e) => {
              onChange && onChange(e);
              return input.onChange(e);
            }}
            checked={
              input.value.toString().indexOf(checkbox.value.toString()) !== -1 || checked
            }
            value={checkbox.value}
          />
        </label>
        {touched && error && (
          <HelpBlock>
            <FormattedMessage
              id={validationMessageKey}
              values={validationValues}
            />
          </HelpBlock>
        )}
      </div>
    </FormGroup>
  );
};

CheckboxInput.propTypes = {
  checkbox: PropTypes.object.isRequired,
  groupClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChange: PropTypes.func,
  meta: PropTypes.object.isRequired,
  validation: PropTypes.object,
  required: PropTypes.bool,
  checked: PropTypes.bool,
};

export default CheckboxInput;



// WEBPACK FOOTER //
// ./src/components/common/form/CheckboxInput.js